import { REGEX_CONSTANT } from "../../../constant/regexConstant";

const validationCompanyProfile = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "company_profile_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_GROLOG_ACC_ID")
        })
      }else {
        error[namespace] = null
      }
      break;
    case "company_status":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:STATUS")
        })
      }else {
        error[namespace] = null
      }
    break;
    case "company_title":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_TITLE")
        })
      }else {
        error[namespace] = null
      }
    break;
    case "company_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_NAME")
        })
      }else if (data?.length > 50 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 50", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_NAME"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "company_email":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_EMAIL")
        })
      }else if (data?.length > 100 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_EMAIL"),
        });
      } else if (!REGEX_CONSTANT.EMAIL.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_EMAIL"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "company_phone":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_PHONE")
        })
      }else if (data?.length > 35 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 35", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_PHONE"),
        });
      } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_PHONE"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "company_fax":
      if (data?.length > 30) {
        error[namespace] = translate("Field cannot be more than 30", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_FAX"),
        });
      } else if (!data || data === "" || data === null) {
        error[namespace] = null
      } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_FAX"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "company_npwp":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_NPWP")
        })
      }else {
        error[namespace] = null
      }
    break;
    case "company_country_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_COUNTRY")
        })
      }else {
        error[namespace] = null
      }
    break;
    case "company_province_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_PROVINCE")
        })
      }else {
        error[namespace] = null
      }
    break;
    case "company_district_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_DISTRICT")
        })
      }else {
        error[namespace] = null
      }
    break;
    case "company_sub_district_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_SUB_DISTRICT")
        })
      }else {
        error[namespace] = null
      }
    break;
    case "company_urban_village_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_URBAN_VILLAGE")
        })
      }else {
        error[namespace] = null
      }
    break;
    case "company_address_1":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_ADDRESS")
        })
      } else if (data?.length > 100 || data?.length <= 1) {
        error[namespace] = translate("Field cannot be less than 1 and more than 100", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_ADDRESS"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "company_address_2":
      if (data?.length > 100) {
        error[namespace] = translate("Number of data must less than 100", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_ADDRESS_2"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "company_address_3":
      if (data?.length > 100) {
        error[namespace] = translate("Number of data must less than 100", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_ADDRESS_3"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "company_postal_code":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_POSTAL_CODE")
        })
      }else {
        error[namespace] = null
      }
    break;
    case "longitude":
      if (!data || data === null || data === ""){
        error[namespace] = null
      } else if (!REGEX_CONSTANT.LNG_LAT.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_LONGITUDE"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "latitude":
      if (!data || data === null || data === ""){
        error[namespace] = null
      } else if (!REGEX_CONSTANT.JUST_LAT.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_LATTITUDE"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "company_neighbour":
      if (!data || data === null || data === ""){
        error[namespace] = null
      } else if (!REGEX_CONSTANT.JUST_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_NEIGHBOURHOOD"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "company_hamlet":
      if (!data || data === null || data === ""){
        error[namespace] = null
      } else if (!REGEX_CONSTANT.JUST_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_HAMLET"),
        });
      } else {
        error[namespace] = null
      }
    break;
    case "bank_name":
      if (data && !REGEX_CONSTANT.CHAR.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_HAMLET"),
        });
      }else if (data.length>256) {
        error[namespace] = translate("Max 20 Character", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_HAMLET"),
        });
      } else {
        error[namespace] = null
      }
    break;
    
    case "bank_account_number":
      if (data && !REGEX_CONSTANT.JUST_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_HAMLET"),
        });
      }else if (data.length>20) {
        error[namespace] = translate("Max 20 Character", {
          field: translate("COMPANY_PROFILE:LBL_COMPANY_HAMLET"),
        });
      } else {
        error[namespace] = null
      }
    break;

    default:
      break;
  }
  return error;
}

export default validationCompanyProfile;